import { XIcon } from '@phosphor-icons/react';
import seliseLogo from '/Logo.svg';
import seliseSmallLogo from '@/assets/images/selise_logo_small.svg';
import { cn } from '@/lib/utils';

interface LogoSectionProps {
  open: boolean;
  isMobile: boolean;
  onClose: () => void;
  /** When the rail is collapsed, clicking the mark expands the sidebar. */
  onExpand?: () => void;
}

export const LogoSection = ({
  open,
  isMobile,
  onClose,
  onExpand,
}: Readonly<LogoSectionProps>) => {
  const showFullLogo = open || isMobile;
  const expandOnMarkClick = Boolean(onExpand) && !showFullLogo;

  return (
    <div
      className={cn(
        'nav-brand flex h-full min-w-0 flex-1 items-center px-[14px]',
        showFullLogo ? 'justify-start' : 'justify-center',
        'group-data-[collapsible=icon]:justify-center'
      )}
    >
      <img
        src={seliseLogo}
        alt="SELISE campaigns"
        className={cn(
          'h-8 w-auto max-w-[9rem] object-contain object-left',
          !showFullLogo && 'hidden',
          'group-data-[collapsible=icon]:hidden'
        )}
      />
      {expandOnMarkClick ? (
        <button
          type="button"
          className="flex size-9 items-center justify-center rounded-md hover:bg-neutral-100"
          aria-label="Expand navigation"
          title="Expand navigation"
          onClick={onExpand}
        >
          <img src={seliseSmallLogo} alt="" className="h-5 w-5 object-contain" />
        </button>
      ) : (
        <img
          src={seliseSmallLogo}
          alt="SELISE"
          className={cn(
            'h-5 w-5 object-contain',
            showFullLogo && 'hidden',
            'group-data-[collapsible=icon]:block'
          )}
        />
      )}

      {isMobile && (
        <button className="ml-auto" onClick={onClose} aria-label="Close sidebar">
          <XIcon size={20} />
        </button>
      )}
    </div>
  );
};
